import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import on from 'dojo/on';
import domConstruct from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import domStyle from 'dojo/dom-style';
import dojoQuery from 'dojo/query';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
// template-instantiated child widgets (data-dojo-type in MaintenanceTaskForm.html) — kept as
// side-effect imports so the AMD loader still preloads them (not referenced as values in code).
import "../../../moreCore/UI/HintBox/HintBox";
import "../../../moreCore/UI/SelectBox/SelectBox";
import "../../../moreCore/UI/GenericDialog/GenericDialog";
import ExecutionChangeDlg from '../TaskExecution/ExecutionChangeDlg';
import MaintenanceInfo from './MaintenanceInfo';
import SimpleFileUpload from '../../../moreCore/UI/SimpleFileUpload/SimpleFileUpload';
import template from './MaintenanceTaskForm.html?raw';

class MaintenanceTaskForm extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    entityID: any = null;
    jsonEntity: any = null; // Entity wies aus der Datenbank kommt
    isDirty = false;
    _formDataUndirty: any = null;

    errorCallback: any = null;
    successCallback: any = null;

    _isEditor = false;
    _canFinish = false;

    readonly = false;

    maintenanceInfo: any = null;

    // Objekt mit Werten die beim Speichern übergeben werden (live / immer aktuell)
    formData: any = {
    };

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        let date = new Date();
        //this.inputWorkingDate.value = dojoDateLocale.format(date, { locale: 'de-de', datePattern: "yyyy-MM-dd", timePattern: "", selector: "date" })
    }

    _setReadonlyAttr(value: any): void {
        if (value != true && value != false) {
            value = this.readonly;
        }
        this.readonly = value;
        //console.log("setreadonly", value);
    }

    _serializeDataHandle: any = null;
    serializeData_delayed(resetDirtyState?: any, bypassReadonly?: any): void {
        if (this._serializeDataHandle != null) {
            clearTimeout(this._serializeDataHandle);
            this._serializeDataHandle = null;
        }

        this._serializeDataHandle = setTimeout(lang.hitch(this, this.serializeData, resetDirtyState, bypassReadonly), 150);
    }

    serializeData(resetDirtyState?: any, bypassReadonly?: any): void {

        if (this._serializeDataHandle != null) {
            clearTimeout(this._serializeDataHandle);
            this._serializeDataHandle = null;
        }

    }

    startup(bReload?: any): void {
        if (this.entityID != null) {
            this.load();
        }
    }


    save(callback?: any): void {

        if (this.continuousSaveMode != true) {
            this.StandbyStart();
        }

        console.log("saveData", this.formData);

        var url = window.appRoot + "Maintenance/SaveMaintenanceTaskExecution";

        this.RequestManager.post(
            url,
            {
                entityID: this.entityID,
                sJsonData: JSON.stringify(this.formData)
            },
            lang.hitch(this, this._onSaveResponse, callback),
            lang.hitch(this, this._onSaveError),
            false // sync
        );
    }

    _onSaveResponse(callback: any, response: any): void {

        //console.log("_onSaveResponse", callback, response);


        this.isDirty = false;
        this._formDataUndirty = this.formData;

        this.StandbyStop();

        if (typeof (callback) == "function") { // zb "dialog mit dieser Form schließen und so"
            callback();
        }
    }

    _onSaveError(error: any): void {
        this.StandbyStop();
        this.handleErrorResponse(error.Message);
    }

    load(): void {

        if (!this.entityID) {
            console.warn("cannot load entity without ID!");
            return;
        }

        this.StandbyStart();

        var url = window.appRoot + "Maintenance/LoadMaintenanceTaskExecution";


        this.RequestManager.post(
            url,
            {
                entityID: this.entityID
            },
            lang.hitch(this, this._onLoadResponse),
            lang.hitch(this, this._onLoadError),
            false // sync
        );
    }

    _onLoadResponse(response: any): void {
        //this.StandbyStop();
        if (typeof (response) == "string") {
            this.jsonEntity = JSON.parse(response);
        } else if (typeof (response) == "object") {
            this.jsonEntity = response;
        }

        console.log("_onLoadResponse", this.jsonEntity);

        if (this.jsonEntity == null || typeof (this.jsonEntity) == "undefined") {
            this.StandbyStop();
            alert("requested item does not exist");
            return;
        }

        this.taskEntity = this.jsonEntity._taskData; // ref_vt_task;


        // Bearbeitbar wenn ich der Meldende bin und der Status dies zulässt
        this.set("Readonly", this.jsonEntity.isReadonly); // was auch immer gesetzt ist - einmal ausführen (u.a. wegen Eskalationscheckbox)

        this.setFormData();
        //this.inputOccurrenceType._loadListValues();

        this.emit("EntityChange", this.jsonEntity);

        this.StandbyStop();
    }

    _onLoadError(error: any): void {
        this.StandbyStop();
        this.handleErrorResponse(error.Message);
    }


    getEntity(): any {
        return this.jsonEntity;
    }


    setFormData(): void {
        //console.info("setFormData", this.jsonEntity);

        if (this.maintenanceInfo != null) {
            domConstruct.empty(this.maintenanceInfoContainer);

        }

        this._displayStatus(this.jsonEntity.ref_scheduled_task_executer_status);

        if (this.jsonEntity._taskData) {
            var data = this.jsonEntity._taskData;
            if (data.ref_Inventar) {
                this.maintenanceInfo = new MaintenanceInfo();
                this.maintenanceInfo.set("entity", data.ref_Inventar);

                this.maintenanceInfo.placeAt(this.maintenanceInfoContainer);
                domClass.remove(this.maintenanceInfoContainer, "w3-hide");
            }

            if (data.tmp_buttonstates) {

                let buttonStates = JSON.parse(data.tmp_buttonstates);
                domClass.remove(this.btnContainerFinish, "w3-disabled");

                domClass.toggle(this.btnContainerFinish, "w3-hide", buttonStates.button_complete != true);
                this._canFinish = buttonStates.button_complete === true;

                domClass.toggle(this.btnContainerPause, "w3-hide", buttonStates.button_pause != true);
                this._canPause = buttonStates.button_pause === true;

                domClass.toggle(this.btnContainerStart, "w3-hide", buttonStates.button_start != true);
                this._canStart = buttonStates.button_start === true;

            }

            domClass.remove(this.sectionTask, "w3-hide");

            var inputs: any = dojoQuery("[data-evisattribute]", this.sectionTask);
            for (var i = 0; i < inputs.length; i++) {
                var input = inputs[i];
                var value = this.PitHelper.getEntityAttributeValue(data, input.dataset["evisattribute"], "json");

                let format = input.dataset["format"];
                let unit = input.dataset["unit"];
                if (unit == "date" && !!format) {
                    try {
                        let date = new Date(value);
                        value = this.dateToString(date, format);
                    } catch (ex) {

                    }
                }
                if (unit == "hours" && !!format) {
                    try {
                        let numbervalue = parseFloat(value);
                        if (isNaN(value)) {
                            value = "-";
                        } else {
                            let hours = 0;
                            let minutes = 0;
                            let seconds = numbervalue * 60 * 60; // zu Sekunden multiplizieren;

                            while (seconds >= 60) {
                                minutes++;
                                seconds = seconds - 60;
                            }

                            while (minutes >= 60) {
                                hours++;
                                minutes = minutes - 60;
                            }

                            value = format.replace("h", hours);
                            value = value.replace("mm", minutes.toLocaleString("de-DE", { minimumIntegerDigits: 2, maximumFractionDigits: 0 }));
                            value = value.replace("m", minutes);
                            value = value.replace("ss", seconds.toLocaleString("de-DE", { minimumIntegerDigits: 2, maximumFractionDigits: 0 }));
                            value = value.replace("s", seconds);
                        }
                    } catch (ex) {
                        // nix, dann halt ned.
                    }
                }

                if (unit == "euro") {
                    try {
                        let numbervalue = parseFloat(value);
                        if (typeof (numbervalue) != "number" || isNaN(value)) {
                            numbervalue = 0;
                            value = "-";
                        } else {
                            value = numbervalue.toLocaleString("de-DE", { currency: "EUR", style: "currency" });
                        }
                    } catch (ex) {
                        // nix, dann halt ned.
                        console.warn("euro unit failed", value, ex);
                    }
                }

                domAttr.set(input, "innerHTML", value);

            }

            this.handleFiles(data);
        }

        domConstruct.empty(this.executerTable);

        if (this.jsonEntity._taskData?.TaskExecutors && this.jsonEntity._taskData.TaskExecutors.length) {
            domClass.remove(this.executerListContainer, "w3-hide");
            for (let data of this.jsonEntity._taskData.TaskExecutors) {
                let row = domConstruct.create("tr", {
                    className: data.ID == this.jsonEntity.ID ? "myExecution" : ""
                }, this.executerTable);

                domConstruct.create("td", {
                    "innerHTML": data.ref_employee.DispName

                }, row);

                domConstruct.create("td", {
                    "innerHTML": data.ref_scheduled_task_executer_status.Name,
                    style: {
                        "backgroundColor": data.ref_scheduled_task_executer_status.DisplayColor.BackColor.Hex,
                        "color": data.ref_scheduled_task_executer_status.DisplayColor.TextColor.Hex
                    }
                }, row);

                let historyTd = domConstruct.create("td", {

                }, row);

                domConstruct.create("pre", {
                    "className": "executerHistory",
                    innerHTML: data.tmp_history_info
                }, historyTd);
            }
        } else {
            domClass.add(this.executerListContainer, "w3-hide");
        }

        this.serializeData(true); // "nicht dirty" setzen
    }

    _displayStatus(status: any): void {
        if (status) {
            this.txtStatus.innerHTML = status.Name;
            domStyle.set(this.statusContainer, "backgroundColor", status.DisplayColor.BackColor.Hex);
            domStyle.set(this.statusContainer, "color", status.DisplayColor.TextColor.Hex);
            domClass.remove(this.statusContainer, "w3-hide");
        } else {
            domClass.add(this.statusContainer, "w3-hide");
        }
    }

    _files: any = [];
    handleFiles(data: any): void {
        // FILES!
        this._files = [];
        let buttonStates = JSON.parse(data.tmp_buttonstates);
        let fileContainer = this.fileContainer;

        this._files.push({ node: fileContainer, ID: data.ID });
        if (data.Files && buttonStates._showFiles === true) {
            domClass.remove(this.sectionFiles, "w3-hide");
            domClass.remove(fileContainer, "w3-hide");

            if (data.Files.length > 0) {

                let heading: any = domConstruct.create("div",
                    {
                        "innerHTML": this.translations["OccurrenceTaskExecutions__FilesHeading"],
                        className: "w3-medium w3-padding-y"
                    },
                    fileContainer);

                let filesTable = domConstruct.create("div", { className: "flex_row" }, heading);


                for (let i = 0; i < data.Files.length; i++) {
                    let file = data.Files[i];

                    let fileRowDiv = domConstruct.create("div",
                        {
                            className: "flex_row_center w3-margin-right w3-light-gray ",
                            //innerHTML: file.Filename
                        },
                        filesTable);

                    domConstruct.create("span",
                        {
                            className: "w3-padding-small",
                            innerHTML: file.Filename
                        }, fileRowDiv)


                    if (file._canDownload === true) {
                        let downloadButton = domConstruct.create("button",
                            {
                                className: "mds-button-base",
                                innerHTML: "<i class='fa fa-download'></i>"
                            },
                            fileRowDiv
                        );

                        domClass.add(fileRowDiv, "mds-hover-dark");

                        on(fileRowDiv, "click", lang.hitch(this, this._onClickDownloadFile, file.ID))
                    }

                    if (file._canRemove) {
                        let removeBtn = domConstruct.create("button",
                            {
                                className: "mds-button-base w3-pale-red mds-hover-dark",
                                innerHTML: "<i class='fa fa-times w3-text-red'></i>"
                            },
                            fileRowDiv
                        );

                        on(removeBtn, "click", lang.hitch(this, this._onClick_RemoveFile, file.ID, data.ID, filesTable));
                    };
                }
            }
        }


        fileContainer = this.fileUploadContainer;
        if (buttonStates._uploadFiles === "nein aktuell deaktiviert!") { //=== true) {
            domClass.remove(this.sectionFiles, "w3-hide");
            let uploadContainer = fileContainer;

            domClass.remove(fileContainer, "w3-hide");

            let fileupload = new SimpleFileUpload();
            fileupload.set("MultipleMode", true);
            fileupload.set("submitCallback", lang.hitch(this, this._onUploadTaskfileResponse));
            fileupload.set("UploadUrl", "Occurrence/UploadTaskFile"); // egal, weil wir eh nicht
            fileupload.set("maxSize", 9);
            domConstruct.place(fileupload.domNode, fileContainer);

            let buttonContainer = domConstruct.create("div", {}, fileContainer);

            on(fileupload, "change", lang.hitch(this, this._onChange_Fileinput, buttonContainer, fileupload, data));

            fileupload.startup();
        }

    }

    _onChange_Fileinput(domnode: any, fileupload: any, data: any): void {
        let uploadData = fileupload.getUploadData();
        console.log("_onChange_Fileinput", domnode, uploadData, data);

        domConstruct.empty(domnode);
        if (uploadData) {
            let button = domConstruct.create("button", {
                className: "mds-button-base round accentcolor w3-padding-small mds-hover-bright",
                innerHTML: "Upload&nbsp;<i class='fa fa-upload'></i>"
            }, domnode);

            on(button, "click", lang.hitch(fileupload, "_StartUpload", { taskID: data.ID }));
        }
    }

    _onUploadTaskfileResponse(response: any): void {
        console.debug("_onUploadTaskfileResponse", response);

    }

    _onClick_RemoveFile(fileID: any, taskID: any, domnode: any, evt: any): void {
        evt.stopPropagation();

        this.StandbyStart(domnode);

        var url = window.appRoot + "Occurrence/RemoveTaskFile";

        let data = { "fileID": fileID, "taskID": taskID };

        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onRemoveTaskFileResponse),
            lang.hitch(this, this._onRemoveTaskFileError),
            false // sync
        );
    }
    _onRemoveTaskFileError(error: any): void {
        console.error(error.Message);
        this.StandbyStop();
    }


    _onRemoveTaskFileResponse(response: any): void {
        this.StandbyStop();

        this.loadScheduledTaskExecutors(); // nix von da oben geht, Tabulator is einfach gschissn. Forever.
    }

    _onClickDownloadFile(fileID: any, evt: any): void {
        evt.stopPropagation();
        //console.debug("_onClickDownloadFile", fileID, evt);

        var url = window.appRoot + "Maintenance/DownloadTaskFile?ID=" + fileID;
        window.open(url);
    }

    showStatusChangeDialog(taskEntity: any, header: any, subtitle: any, callback: any): void {
        var dialog = new ExecutionChangeDlg();
        this.executionChangeDlg = dialog;
        dialog.setup(taskEntity, header, subtitle, callback, "-WD-WA");
        dialog.show();
    }

    _onClick_Finish(evt: any): void {
        if (!this._canFinish) {
            return;
        }

        this._canFinish = false;
        domClass.add(this.btnContainerFinish, "w3-disabled");

        let taskEntity = this.jsonEntity;

        let header = this.translations["OccurrenceTaskExecutions__DialogConfirmFinishHeading"].format(taskEntity.Number);
        let subtitle = this.translations["OccurrenceTaskExecutions__DialogConfirmFinish"].format(taskEntity.Number);


        //this.changeTaskStatus("ID_scheduled_task_executer_status_done");
        this.showStatusChangeDialog(taskEntity,
            header,
            subtitle,
            lang.hitch(this,
                this.changeTaskStatus,
                taskEntity,
                "ID_scheduled_task_executer_status_done"
            )
        );
    }
    _onClick_Pause(evt: any): void {
        let taskEntity = this.taskEntity;
        let header = this.translations["OccurrenceTaskExecutions__DialogPauseHeading"].format(taskEntity.Number);
        let subtitle = this.translations["OccurrenceTaskExecutions__DialogPause"].format(taskEntity.Number);

        this.showStatusChangeDialog(taskEntity,
            header,
            subtitle,
            lang.hitch(this,
                this.changeTaskStatus,
                taskEntity,
                "ID_scheduled_task_executer_status_pause"
            )
        );

    }


    changeTaskStatus(taskEntity: any, targetState: any, result?: any): void {

        console.debug("changeTaskStatus", result, taskEntity, data);

        // antwort vom Dialog? (bei Pausieren)
        if (typeof (result) != "undefined") {

            if (result < 1) { // Abbruch
                return;
            }

        } else {
            return;
        }

        this.StandbyStart();

        var url = window.appRoot + "Maintenance/ChangeExecuterStatus";

        var data = this.executionChangeDlg.getData();

        data.targetState = targetState;


        this.RequestManager.post(
            url,
            {
                taskID: this.jsonEntity._taskData.ID,
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, "_onChangeExecuterStatusResponse"),
            lang.hitch(this, "_onChangeExecuterStatusError"),
            false // sync
        );
    }

    _onChangeExecuterStatusResponse(response: any): void {
        this.load();
        this.StandbyStop();

        this.emit("EntityStored");
    }

    _onChangeExecuterStatusError(error: any): void {
        this.setFormData();
        this.StandbyStop();

        alert("Saving failed - maybe try again\r\n" + error.Message);
    }

    setEntityIDAttr(entityID: any): void {
        this.entityID = entityID;
    }


    handleErrorResponse(message: any): void {
        if (typeof (this.errorCallback) == "function") {
            this.errorCallback(message);
            return;
        }

        // ansonsten Fehlermeldung selber irgendwo platzieren?
        else {
            alert(message);
        }
    }

    handleSuccessResponse(): void {
        if (typeof (this.successCallback) == "function") {
            this.successCallback();
            return;
        }
    }
}
MaintenanceTaskForm.prototype.declaredClass = 'WidgetCollection.Maintenance.MaintenanceTaskForm';

export default mdsWidget(MaintenanceTaskForm);
